<tam-dialog class="map-tile-container" tid="map-tile-container" [opened]="isOpen" [dialogWidth]="dialogWidth"
    (keydown.esc)="onCancelClick()">
    <ng-template #title>
        <div class="dialog-title">
            <span>Map tile</span>
        </div>
        <div class="dialog-close">
            <smart-icon class="dark small" name="close" (click)="onCancelClick()"></smart-icon>
        </div>
    </ng-template>

    <ng-template #body>
        <tam-dashboard-map-tile [config]="configMapTile" [mapConfig]="mapConfig"
            [isFromShowEventOnMapTile]="isFromShowEventOnMapTile" [mapContactModel]="mapContactModel">
        </tam-dashboard-map-tile>
    </ng-template>

    <ng-template #footer>
        <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button dialog-cancel"
            (click)="onCancelClick($event)">{{'general.cancel' |
            stringLiterals}}</button>
    </ng-template>
</tam-dialog>